import React, { useContext, useMemo } from "react";
import { useMutation } from "@tanstack/react-query";
import { Transaction } from "@common/types/transaction";
import { ClassCombobox } from "@components/transactions/TransactionSplitV2/ClassCombobox";
import { useClasses } from "@api/class.api";
import { TransactionDetailsContext } from "./transactionDetails.context";
import { TransactionDetailsField } from "./TransactionDetailsField";
import styles from "./TransactionDetailsClass.module.scss";

interface Props {
    transaction: Transaction;
    isLocked?: boolean;
    lockTooltip?: string;
}

export const TransactionDetailsClass: React.FC<Props> = ({
    transaction,
    isLocked,
    lockTooltip,
}) => {
    const { onUpdate } = useContext(TransactionDetailsContext);
    const { isActivated } = useClasses();

    const selectedClassIds = useMemo(
        () => (transaction.classAssignments ?? []).map((a) => a.classId),
        [transaction.classAssignments],
    );

    const updateClasses = useMutation({
        mutationFn: async (classIds: string[]) => {
            await onUpdate({ classIds });
        },
    });

    if (!isActivated) {
        return null;
    }

    return (
        <TransactionDetailsField
            label="Class"
            value={
                <ClassCombobox
                    selectedClassIds={selectedClassIds}
                    onChange={(classIds) => {
                        if (!isLocked) {
                            updateClasses.mutate(classIds);
                        }
                    }}
                    disabled={isLocked}
                    placeholder="Set class"
                    className={styles.classTrigger}
                    hideArrow
                    triggerButtonProps={{
                        tooltip: lockTooltip,
                        disabled: isLocked,
                    }}
                />
            }
        />
    );
};
